import { yayApi } from '../baseApi'

export const communityCampaignApi = yayApi.injectEndpoints({
  endpoints: (build) => ({
    getCommunityCampaign: build.query<
      {
        eligible_for_apply: boolean
        viewable_group_leaderboard: boolean
      },
      void
    >({
      query: () => ({
        url: '/v1/community_campaign',
      }),
    }),

    getCommunityCampaignGroupLeaderboard: build.query<
      {
        group_leaderboard: Array<{
          ranking: number
          total_scores: number
          group: {
            id: number
            topic: string
            group_icon?: string
            group_icon_thumbnail?: string
          }
        }>
        updated_at: number
      },
      void
    >({
      query: () => ({
        url: '/v1/community_campaign/group_leaderboard',
      }),
    }),

    getCommunityCampaignGroupsUserLeaderboard: build.query<
      {
        user_leaderboard: Array<{
          ranking: number
          total_scores: number
          updated_at: number
          top_gifts: Array<string>
          user: {
            id: number
            username: any
            nickname: string
            profile_icon: string
            profile_icon_thumbnail: string
          }
        }>
      },
      {
        groupId: number
      }
    >({
      query: ({ groupId }) => ({
        url: `/v1/community_campaign/groups/${groupId}/user_leaderboard`,
      }),
    }),
  }),

  overrideExisting: false,
})

export const {
  useGetCommunityCampaignQuery,
  useGetCommunityCampaignGroupLeaderboardQuery,
  useGetCommunityCampaignGroupsUserLeaderboardQuery,
} = communityCampaignApi
